export default "__VITE_ASSET__kSHvwCjLFxLpY3FM1MyAsA__"